import {BRANCH_SOURCING_CACHE_TAGS, SOURCING_CONTEXT_CACHE_TAGS} from '@dms/api/core';

import {buildArray} from 'shared/web';

import {isSourcingContextSettingKey} from './isSourcingContextSettingKey';

/** `getUserStats` (`providesTags: ['User']`) — branch-scoped counts in sourcing nav. */
const BRANCH_USER_CACHE_TAGS = ['User'] as const;

export type SetUserSettingsInvalidationTag =
  | 'CurrentUser'
  | (typeof SOURCING_CONTEXT_CACHE_TAGS)[number]
  | (typeof BRANCH_SOURCING_CACHE_TAGS)[number]
  | (typeof BRANCH_USER_CACHE_TAGS)[number];

/**
 * Composes CurrentUser + domain tags for `setUserSettingsItem`.
 * Sourcing tag lists live in `@dms/api/core`; `User` covers getUserStats on branch switch.
 */
export const getSetUserSettingsInvalidationTags = (
  settingKey: string
): SetUserSettingsInvalidationTag[] => {
  const isSourcingContext = isSourcingContextSettingKey(settingKey);
  const isActiveBranch = settingKey === 'active_branch';

  return buildArray<SetUserSettingsInvalidationTag>(['CurrentUser'])
    .when(isSourcingContext, ...SOURCING_CONTEXT_CACHE_TAGS)
    .when(isActiveBranch, ...BRANCH_SOURCING_CACHE_TAGS, ...BRANCH_USER_CACHE_TAGS);
};
